'use strict';

angular.module('DoohApps').run(['$rootScope', '$location', '$uibModal', '$filter', 'Account', '$routeParams', 'AppStoreDataFilter', 'CampaignDataFilter', '$route', 'SessionData', 'CompanyBLL', 'DialogHandler', 'Hub', 'DoohConfig', '$window', 'SessionHelper', '$anchorScroll', 'User', 'AccountService',
    function ($rootScope, $location, $uibModal, $filter, Account, $routeParams, AppStoreDataFilter, CampaignDataFilter, $route, SessionData, CompanyBLL, DialogHandler, Hub, DoohConfig, $window, SessionHelper, $anchorScroll, User, AccountService) {
        $rootScope.user = User;
        $rootScope.$route = $route;
        $rootScope.DoohConfig = DoohConfig;
        $rootScope.year = new Date().getFullYear();

        $rootScope.corruptAuthToken = function () {
            SessionData.corruptAuthToken();
        };

        $rootScope.corruptRefreshToken = function () {
            SessionData.corruptRefreshToken();
        };

        $rootScope.Menu = {
            Dashboard: {
                Name: 'Dashboard',
                Title: 'Dashboard',
                ImageUrl: 'Content/menuIcons/ico_nav_dashboard_on.png'
            },
            MediaAssets: {
                Name: 'MediaAssets',
                Title: 'My assets',
                ImageUrl: 'Content/menuIcons/ico_nav_media-assets_on.png'
            },
            AppInbox: {
                Name: 'AppInbox',
                Title: 'App Inbox',
                ImageUrl: 'Content/menuIcons/ico_nav_app-inbox_on.png'
            },
            Schedule: {
                Name: 'Schedule',
                Title: 'Schedule',
                ImageUrl: 'Content/menuIcons/ico_nav_schedules_on.png'
            },
            Devices: {
                Name: 'Devices',
                Title: 'Devices',
                ImageUrl: 'Content/menuIcons/device_icon4_blue.png'
            },
            Reporting: {
                Name: 'Reporting',
                Title: 'Reporting',
                ImageUrl: 'Content/menuIcons/ico_nav_reporting_on.png'
            },
            Account: {
                Name: 'Account',
                Title: 'Account',
                ImageUrl: 'Content/menuIcons/ico_nav_account_on.png'
            },
            Admin: {
                Name: 'Admin',
                Title: 'System admin',
                ImageUrl: 'Content/menuIcons/crown_on.png'
            },
            AppAdmin: {
                Name: 'AppAdmin',
                Title: 'Developer',
                ImageUrl: 'Content/menuIcons/app_admin_on.png'
            }
        };

        $location.path_base = $location.path;
        $location.path = function (path, reload) {
            $rootScope.location = $location.$$path;

            if (reload === false) {
                var lastRoute = $route.current;
                var un = $rootScope.$on('$locationChangeSuccess', function () {
                    if (typeof ($route.current) != 'undefined')
                        if ((typeof ($route.current.$$route) != 'undefined') &&
                            $route.current.params.configure == undefined) {
                            $route.current = lastRoute;
                        }
                    un();
                });
            }

            return this.path_base.apply($location, [path]);
        };

        $rootScope.goto = function (url, params) {
            if (params == undefined)
                params = {};
            $location.path(url).search(params);
        };

        $rootScope.scrollTo = function (hash) {
            $anchorScroll(hash);
        }

        $rootScope.REGEX = {
            EMAIL_REGEXP: /^([^@\s\."'\(\)\[\]\{\}\\/,:;]+\.)*[^@\s\."'\(\)\[\]\{\}\\/,:;]+@[^@\s\."'\(\)\[\]\{\}\\/,:;]+(\.[^@\s\."'\(\)\[\]\{\}\\/,:;]+)+$/,//support for special character emails
            PHONE_REGEXP: /^(\+)?([0-9]){5,25}$/i,
            DATEF_REGEXP: /^\b(([d]{1,2}))([\,\-\/\.\s]){1,2}(([M]{1,4}))([\,\-\/\.\s]){1,2}((([y]{4})|([y]{2})))\b$|^\b(([M]{1,4}))([\,\-\/\.\s]){1,2}(([d]{1,2}))([\,\-\/\.\s]){1,2}((([y]{4})|([y]{2})))\b$|^\b((([y]{4})|([y]{2})))([\,\-\/\.\s]){1,2}(([M]{1,4}))([\,\-\/\.\s]){1,2}(([d]{1,2}))\b$/,
            TIMEF_REGEXP: /^\b([H][H]?:[m][m])\b$|^\b([h][h]?:[m][m]\sa)\b$/,
            NAME_REGEXP: /^([^0-9!@#$%^&*()_+=\-.,/\\|\[\]{}\'\"\;\:\?\<>`~])+$/i
        };

        $rootScope.DATE_FORMAT = localStorage['DateFormat'];//'yyyy-MM-dd HH:mm';
        $rootScope.SHORT_DATE = localStorage['ShortDateFormat'];//'yyyy-MM-dd';
        $rootScope.TIMEFORMAT = localStorage['TimeFormat'];

        if ($rootScope.SHORT_DATE != undefined) {
            $rootScope.SHORT_DATE_MOMENT = $rootScope.SHORT_DATE.replace(/d/g, 'D').replace(/y/g, 'Y');
        }

        $rootScope.ActiveSection = $rootScope.Menu.Dashboard;
        $rootScope.accountService = AccountService;
        $rootScope.changeFilter = function (obj, param, reset) {
            reset(obj, param);

            if (obj[param] == 2) obj[param] -= 1;
            else obj[param] += 1;
        };

        if (User.isLoggedIn) {
            Hub.Start(User.company.id, User.id);
        }
    }
]);